var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

/**
 * RegisteredAlgorithms
 */
var RegisteredAlgorithms =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * Constructor
   *
   * @param {Object} mapping
   */
  function RegisteredAlgorithms(mapping) {
    _classCallCheck(this, RegisteredAlgorithms);

    Object.assign(this, mapping);
  }
  /**
   * getCaseInsensitive
   *
   * @param {string} algName
   * @returns {string}
   */


  _createClass(RegisteredAlgorithms, [{
    key: "getCaseInsensitive",
    value: function getCaseInsensitive(algName) {
      for (var key in this) {
        if (key.match(new RegExp("^".concat(algName, "$"), 'i'))) {
          return key;
        }
      }
    }
  }]);

  return RegisteredAlgorithms;
}();
/**
 * Export
 */


module.exports = RegisteredAlgorithms;